module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error500_1f13cbd.png";